
import * as React from "react";
import { Helmet } from "react-helmet-async";
import { PaletteMode, Container, Button, Typography, Stack } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import AppAppBar from "../../components/layout/AppAppBar";
import Footer from "../../components/layout/Footer";
import getLPTheme from "../../getLPTheme";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import PayBanner from "../../components/common/PayBanner";

export default function DownloadPage() {
  const [mode, setMode] = React.useState<PaletteMode>("light");
  const LPtheme = createTheme(getLPTheme(mode));
  const [isBannerVisible, setIsBannerVisible] = React.useState(false);

  const toggleColorMode = () => {
    setMode((prev) => (prev === "dark" ? "light" : "dark"));
  };

  const handleBannerStateChange = (isVisible: boolean) => {
    setIsBannerVisible(isVisible);
  };

  const handleDownloadAPK = () => {
    localStorage.setItem('install_initiated', 'true');
    window.location.href = 'https://offer.app20.in/apk';
  };

  return (
    <ThemeProvider theme={LPtheme}>
      <CssBaseline />
      <Helmet>
        <title>Download App20 - Official App</title>
        <meta name="description" content="Download the official App20 app and start earning today." />
      </Helmet>

      <Box
        sx={{
          background: "linear-gradient(180deg, #FFF3E0 0%, #FFFFFF 50%, #FFB300 100%)",
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <AppAppBar
          mode={mode}
          toggleColorMode={toggleColorMode}
          isBannerVisible={isBannerVisible}
          transparentMode={true}
          useTextLogo={false}
          simpleNavbar={true}
        />
        <PayBanner onBannerStateChange={handleBannerStateChange} />

        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', py: { xs: 8, md: 12 } }}>
          <Container maxWidth="md">
            <Stack
              spacing={4}
              alignItems="center"
              textAlign="center"
            >
              <Box>
                <Typography
                  sx={{
                    fontWeight: 900,
                    color: "#3F51B5",
                    mb: 1,
                    fontSize: { xs: '48px', md: '80px' },
                    lineHeight: 1,
                    fontFamily: "'General-Sans-bold', sans-serif",
                    letterSpacing: '-1px'
                  }}
                >
                  Get the <br />
                  <span style={{ color: '#FFB300' }}>App20 App</span>
                </Typography>

                <Typography
                  sx={{
                    color: 'text.secondary',
                    mt: 3,
                    maxWidth: '550px',
                    mx: 'auto',
                    fontSize: { xs: '18px', md: '22px' },
                    lineHeight: 1.4,
                    fontWeight: 500,
                  }}
                >
                  Join thousands of users earning daily. <br />
                  Simple, safe, and officially verified.
                </Typography>
              </Box>

              <Box sx={{ mt: 2 }}>
                <Button
                  variant="contained"
                  onClick={handleDownloadAPK}
                  sx={{
                    background: "linear-gradient(135deg, #FFB300 0%, #FFA500 100%)",
                    color: '#000',
                    fontWeight: 900,
                    fontSize: { xs: '20px', md: '26px' },
                    py: { xs: 2, md: 2.5 },
                    px: { xs: 6, md: 10 },
                    borderRadius: '100px',
                    textTransform: 'none',
                    fontFamily: "'General-Sans-bold', sans-serif",
                    boxShadow: '0 20px 40px rgba(255, 179, 0, 0.3)',
                    border: '2px solid rgba(255, 255, 255, 0.3)',
                    "&:hover": {
                      background: "linear-gradient(135deg, #FFA500 0%, #FF8F00 100%)",
                      boxShadow: '0 25px 50px rgba(255, 179, 0, 0.5)',
                      transform: 'translateY(-5px)',
                    },
                    transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                  }}
                  startIcon={<FileDownloadIcon sx={{ fontSize: '32px !important' }} />}
                >
                  Download Now
                </Button>

              </Box>
            </Stack>
          </Container>
        </Box>

        <Footer />
      </Box>
    </ThemeProvider>
  );
}
